// Structured mapping of real activity_logs action -> feed tab + human label + icon.
// Actions verified live from activity_logs. Unknown actions fall back by role.
export const EVENT_MAP = {
  // ---- CUSTOMER ----
  customer_registered: { tab: "customer", label: "Customer registered", icon: "UserPlus" },
  request_created: { tab: "customer", label: "Professional request raised", icon: "Send" },
  professional_request_raised: { tab: "customer", label: "Professional request raised", icon: "Send" },
  material_request_raised: { tab: "customer", label: "Raw material request raised", icon: "Package" },
  raw_material_request: { tab: "customer", label: "Raw material request raised", icon: "Package" },
  customer_selected_professional: { tab: "customer", label: "Customer selected professional", icon: "UserCheck" },
  customer_query_raised: { tab: "customer", label: "Customer raised a query", icon: "MessageCircleQuestion" },
  customer_responded: { tab: "customer", label: "Customer responded", icon: "MessageCircle" },
  project_started: { tab: "customer", label: "Project started", icon: "PlayCircle" },
  milestone_completed: { tab: "customer", label: "Milestone completed", icon: "CircleCheckBig" },
  payment_made: { tab: "customer", label: "Payment made", icon: "CreditCard" },
  payment_captured: { tab: "customer", label: "Payment captured", icon: "CreditCard" },

  // ---- PROFESSIONAL ----
  professional_registered: { tab: "professional", label: "Professional registered", icon: "UserPlus" },
  professional_draft_saved: { tab: "professional", label: "Onboarding draft saved", icon: "Save" },
  professional_submitted: { tab: "professional", label: "Onboarding submitted", icon: "FileUp" },
  documents_uploaded: { tab: "professional", label: "Documents uploaded", icon: "Paperclip" },
  professional_correction: { tab: "professional", label: "Correction requested", icon: "TriangleAlert" },
  professional_approve: { tab: "professional", label: "Professional approved", icon: "BadgeCheck" },
  professional_approved: { tab: "professional", label: "Professional approved", icon: "BadgeCheck" },
  professional_activate: { tab: "professional", label: "Professional activated", icon: "BadgeCheck" },
  professional_reject: { tab: "professional", label: "Professional rejected", icon: "CircleX" },
  professional_responded: { tab: "professional", label: "Responded to a lead", icon: "MessageSquareReply" },
  professional_withdrew_response: { tab: "professional", label: "Withdrew lead response", icon: "Undo2" },
  lead_received: { tab: "professional", label: "Lead received", icon: "Inbox" },
  lead_accepted: { tab: "professional", label: "Lead accepted", icon: "Check" },
  lead_rejected: { tab: "professional", label: "Lead rejected", icon: "X" },
  visit_logged: { tab: "professional", label: "Visit completed", icon: "MapPinCheck" },
  visit_completed: { tab: "professional", label: "Visit completed", icon: "MapPinCheck" },
  work_started: { tab: "professional", label: "Work started", icon: "Hammer" },
  milestone_started: { tab: "professional", label: "Work / milestone started", icon: "Hammer" },
  milestone_updated: { tab: "professional", label: "Milestone updated", icon: "Milestone" },
  work_completed: { tab: "professional", label: "Work completed", icon: "CircleCheckBig" },
  site_location_set: { tab: "professional", label: "Site location set", icon: "MapPin" },

  // ---- SYSTEM / OPERATIONS ----
  lead_floated: { tab: "system", label: "Lead floated", icon: "Radar" },
  lead_distributed: { tab: "system", label: "Lead floated", icon: "Radar" },
  lead_expired: { tab: "system", label: "Lead expired", icon: "TimerOff" },
  professional_assigned: { tab: "system", label: "Professional assigned", icon: "UserCog" },
  project_created: { tab: "system", label: "Project created", icon: "FolderPlus" },
  project_status_changed: { tab: "system", label: "Project status changed", icon: "RefreshCw" },
  ops_released_to_customer: { tab: "system", label: "Responses released to customer", icon: "Share2" },
  command_center_release: { tab: "system", label: "Command Center released leads", icon: "Share2" },
  cleanup_proposed: { tab: "system", label: "Cleanup proposed", icon: "Trash2" },
  product_approve: { tab: "system", label: "Product approved", icon: "PackageCheck" },
};

export const humanize = (s = "") => String(s).replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export function eventMeta(log) {
  const action = log.action || log.change_type || "";
  if (EVENT_MAP[action]) return EVENT_MAP[action];
  const role = log.performed_by_role;
  const tab = role === "customer" ? "customer"
    : role === "professional" || role === "field" ? "professional"
    : action.startsWith("customer") ? "customer"
    : action.startsWith("professional") ? "professional"
    : "system";
  return { tab, label: humanize(action) || "Activity", icon: "Activity" };
}

export const TAB_META = {
  customer: { label: "Customer", icon: "Users", tone: "text-emerald-600 bg-emerald-50 border-emerald-200" },
  professional: { label: "Professional", icon: "Briefcase", tone: "text-indigo-600 bg-indigo-50 border-indigo-200" },
  system: { label: "System / Operations", icon: "ServerCog", tone: "text-cyan-600 bg-cyan-50 border-cyan-200" },
};
